// extracted by mini-css-extract-plugin
export default {"floatingActionButton":"floatingActionButton--JHjXg","hide":"hide--hqcKP"};